<template>
  <div class="home">
    <div class="sign-out" @click.stop="signOut">退出</div>
    <div class="top">
      <img
        class="title"
        src="https://cdnvue.gymcity.com.cn/uploads/4e3b80cf3586a480b7f039432e92a02f.png"
      />
      <img
        class="avatar"
        :src="(userInfo && userInfo.user_img) || defaultAvatar"
      />
      <div class="welcome">
        {{ (userInfo && userInfo.user_name) || '用户' }}，你好！
      </div>
    </div>
    <div class="menu-list">
      <div
        class="menu-item"
        v-for="(item, index) in menuList"
        :key="index"
        @click="jumpPage(index)"
      >
        <div class="icon-content">
          <img class="menu-icon" :src="(item && item.icon) || defaultIconUrl" />
          <div class="number" v-if="item.news > 0">
            +{{ item.news | formatNumber }}
          </div>
        </div>
        <div class="menu-text">{{ item.name }}</div>
        <div class="total-num" v-if="item._list">
          总数：{{ (item._list && item._list.total) || 0 }}
        </div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import { menuData } from './data'
import { jumpUrl } from '@/views/business-center/common/common.js'
import { mapMutations } from 'vuex'
export default {
  name: 'fatcamp-home',
  components: {},
  data() {
    return {
      userInfo: null,
      loaded: false,
      defaultAvatar:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/admin/storage/pic/111ae674549d4b8eed2046e3e08363dd.png',
      defaultIconUrl:
        'https://cdnvue.gymcity.com.cn/uploads/38b1febf45a7a6d19afcb713112a507d.png',
      menuList: []
    }
  },
  filters: {
    formatNumber(num) {
      num = +num
      if (isNaN(num)) {
        return 0
      }
      num = num > 999 ? 999 : num
      return num
    }
  },
  created() {},
  activated() {
    if (!this.menuList.length) {
      this.getHome()
    }
  },
  mounted() {},
  methods: {
    ...mapMutations({
      setStoreUserinfo: 'setUserinfo'
    }),
    getHome() {
      this.$http
        .getApp('member/StorageLogin/getHome', {})
        .then((res) => {
          console.log(res)
          res = res.data
          if (res.code == 200) {
            this.userInfo = res.data.user
            this.setStoreUserinfo(res.data.user)
            this.menuList = this.dealTypeData(res.data.types)
            this.loaded = true
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    },
    dealTypeData(list) {
      let data = list.map((item) => {
        Object.assign(item, menuData[item.id])
        return item
      })
      return data
    },
    jumpPage(index) {
      if (this.menuList[index].num < 2 && !this.menuList[index].check_url) {
        this.$toast('暂无内容')
        return
      }
      let params = {
        type: this.menuList[index].type,
        level: this.menuList[index].num,
        id: this.menuList[index].id,
        title: this.menuList[index].name
      }
      let page = this.menuList[index].check_url
      if (page) {
        if (page.indexOf('http') == 0) {
          jumpUrl(page + '?title=' + params.title)
          return
        } else {
          this.$router.push({
            path: page,
            query: params
          })
        }
      } else {
        this.$router.push({
          path: '/fatcamp/knowledge-base/second_class',
          query: params
        })
      }
    },
    signOut() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认退出登录？'
        })
        .then(() => {
          localStorage.removeItem('storageToken')
          // on confirm
          this.$router.replace('/fatcamp/login')
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  position: relative;
  background-color: rgb(247, 247, 247);
  min-height: 100vh;
  width: 100%;
}
.sign-out {
  padding: 4px 15px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 20px;
  right: 10px;
  border-radius: 6px;
  color: #f1f1f1;
  font-size: 13px;
}
.home .top {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url('https://cdnvue.gymcity.com.cn/uploads/1614133385479fd34b285f7516ecb57b.png');
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;
}
.top .title {
  width: 30.7vw;
  margin-top: 10.1vw;
  margin-bottom: 6.1vw;
}
.top .avatar {
  width: 19.2vw;
  height: 19.2vw;
  border-radius: 9.6vw;
  overflow: hidden;
  margin-bottom: 2.7vw;
}
.top .welcome {
  height: 7.5vw;
  font-family: PingFangSC-Medium;
  font-size: 5.3vw;
  line-height: 7.5vw;
  color: #000;
  margin-bottom: 1.3vw;
  font-weight: 600;
}
.top .desc {
  position: relative;
  width: 343px;
  height: 30px;
  background-color: #fffbf1;
  border-radius: 4px;
}
.top .notice {
  position: absolute;
  top: 50%;
  left: 3%;
  transform: translate(0%, -50%);
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #a05f31;
}
.home .menu-list {
  padding: 7.2vw 5.3vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.icon-content {
  position: relative;
  margin-bottom: 10px;
}
.total-num {
  height: 14px;
  line-height: 14px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.3);
}
.icon-content .number {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(60%, -40%);
  width: 34px;
  height: 20px;
  background-color: #ff5a5a;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: PingFangSC-Semibold;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.menu-item {
  margin-right: 4vw;
  margin-bottom: 4vw;
  width: 42.7vw;
  height: 32vw;
  background-color: #ffffff;
  box-shadow: 0vw 0.5vw 1.1vw 0vw rgba(0, 0, 0, 0.1);
  border-radius: 2.7vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.menu-item:nth-child(2n) {
  margin-right: 0vw;
}
.menu-item .menu-icon {
  width: 11.7vw;
  height: 11.7vw;
}
.menu-item .menu-text {
  text-align: center;
  line-height: 20px;
  padding: 0px 5px;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PingFangSC-Regular;
  font-size: 3.7vw;
  color: #000000;
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
